import { isProductionEnv } from 'src/api';
import { generateHardcodeBonusesObject, generatePrizeAmountObject } from './utils';

// API ENDPOINTS
export const GAME_ENDPOINT = {
  BANNER: 'catch_easter_chick_banner',
  HOW_TO_PLAY: 'catch_easter_chick_how_to_play',
  TERMS: 'catch_easter_chick_terms',
  GAME_END: 'catch_easter_chick_end'
};

export const GAME_TIMER = 45;

export const CATCH_MODAL = {
  PLAY_GAME: 'PLAY_GAME' as const,
  WIN_GAME: 'WIN_GAME' as const,
  END_TIME_GAME: 'END_TIME_GAME' as const,
  UP_LEVEL: 'UP_LEVEL' as const,
  END_GAME: 'END_GAME' as const,
  LOSS_GAME: 'LOSS_GAME' as const,
  LOST_ALL_CHANCES: 'LOST_ALL_CHANCES' as const
};

export type CatchModal = keyof typeof CATCH_MODAL | null;

export const CATCH_GAME_KEY = 'chick_hunt_2025';

export const HARDCORE_BONUS_ID: { [UTC_DAY: number]: number[] } = isProductionEnv
  ? {
      // Only production bonus ids
      8: [589, 590, 591, 592, 593, 594],
      9: [607, 608, 609, 610, 611, 612],
      14: [595, 596, 597, 598, 599, 600],
      15: [613, 614, 615, 616, 617, 618],
      19: [601, 602, 603, 604, 605, 606],
      20: [619, 620, 621, 622, 623, 624]
    }
  : generateHardcodeBonusesObject([313, 314, 315, 316, 317, 318]);

export const MIN_DEPOSIT_AMOUNT: any = {
  EUR: 30,
  USD: 30,
  NZD: 45,
  CHF: 30,
  AUD: 45,
  NOK: 300,
  CAD: 45,
  PLN: 150,
  RON: 150,
  DRL: 150,
  DKK: 225,
  SEK: 300,
  INR: 2700,
  ISK: 4500,
  CZK: 750,
  BRL: 150
};

const PRIZE_AMOUNT_FOR_PROD: Record<number, number> = {
  8: 50,
  9: 75,
  14: 50,
  15: 75,
  19: 50,
  20: 100
};

export const SNOWFLAKES_AMOUNT_BY_DATE: { [day: number]: number } =
  generatePrizeAmountObject(PRIZE_AMOUNT_FOR_PROD);

export const catchDaysStructure = {
  20: {
    idBonusWin: HARDCORE_BONUS_ID[20],
    attempts: []
  },
  21: {
    idBonusWin: HARDCORE_BONUS_ID[21],
    attempts: []
  },
  22: {
    idBonusWin: HARDCORE_BONUS_ID[22],
    attempts: []
  },
  27: {
    idBonusWin: HARDCORE_BONUS_ID[27],
    attempts: []
  },
  28: {
    idBonusWin: HARDCORE_BONUS_ID[28],
    attempts: []
  },
  29: {
    idBonusWin: HARDCORE_BONUS_ID[29],
    attempts: []
  },
  // этот блок надо будет удалить
  1: {
    idBonusWin: HARDCORE_BONUS_ID[1],
    attempts: []
  },
  2: {
    idBonusWin: HARDCORE_BONUS_ID[2],
    attempts: []
  },
  3: {
    idBonusWin: HARDCORE_BONUS_ID[3],
    attempts: []
  },
  4: {
    idBonusWin: HARDCORE_BONUS_ID[4],
    attempts: []
  },
  5: {
    idBonusWin: HARDCORE_BONUS_ID[5],
    attempts: []
  },
  6: {
    idBonusWin: HARDCORE_BONUS_ID[6],
    attempts: []
  },
  7: {
    idBonusWin: HARDCORE_BONUS_ID[7],
    attempts: []
  },
  8: {
    idBonusWin: HARDCORE_BONUS_ID[8],
    attempts: []
  },
  9: {
    idBonusWin: HARDCORE_BONUS_ID[9],
    attempts: []
  },
  10: {
    idBonusWin: HARDCORE_BONUS_ID[10],
    attempts: []
  },
  11: {
    idBonusWin: HARDCORE_BONUS_ID[11],
    attempts: []
  },
  12: {
    idBonusWin: HARDCORE_BONUS_ID[12],
    attempts: []
  },
  13: {
    idBonusWin: HARDCORE_BONUS_ID[13],
    attempts: []
  },
  19: {
    idBonusWin: HARDCORE_BONUS_ID[19],
    attempts: []
  },
  18: {
    idBonusWin: HARDCORE_BONUS_ID[18],
    attempts: []
  },
  17: {
    idBonusWin: HARDCORE_BONUS_ID[17],
    attempts: []
  },
  16: {
    idBonusWin: HARDCORE_BONUS_ID[16],
    attempts: []
  },
  15: {
    idBonusWin: HARDCORE_BONUS_ID[15],
    attempts: []
  },
  14: {
    idBonusWin: HARDCORE_BONUS_ID[14],
    attempts: []
  },
  23: {
    idBonusWin: HARDCORE_BONUS_ID[23],
    attempts: []
  },
  24: {
    idBonusWin: HARDCORE_BONUS_ID[24],
    attempts: []
  },
  25: {
    idBonusWin: HARDCORE_BONUS_ID[25],
    attempts: []
  },
  26: {
    idBonusWin: HARDCORE_BONUS_ID[26],
    attempts: []
  },
  30: {
    idBonusWin: HARDCORE_BONUS_ID[30],
    attempts: []
  },
  31: {
    idBonusWin: HARDCORE_BONUS_ID[31],
    attempts: []
  }
  //
};
